import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit, AfterViewInit {
    public message?: string;
    public warning = false;
    public title = 'Confirm deletion';
    public confirmBtn = 'Confirm';
    public cancelBtn = 'Cancel';
    public customConfirm!: string | boolean
    public customCancel!: string | boolean
    @Input() showActionButtons = true
    @ViewChild('element') element?: ElementRef;

    constructor(private dialogRef: NgbActiveModal) {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        if (this.element) {
            (this.element.nativeElement as HTMLDivElement).focus();
        }
    }


    close(result = false) {
        this.dialogRef.close(result);
    }


    confirm() {
        if (this.customConfirm) {
            this.dialogRef.close(this.customConfirm)
        } else [
            this.close(true)
        ]
    }

    cancel() {
        if (this.customCancel) {
            this.dialogRef.close(this.customCancel)
        } else {
            this.close()
        }
    }
}
